import { useState, useEffect } from "react"

// Run this once, only on the client
const isMobileDevice = () => {
	if (typeof navigator === "undefined") return false
	return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}

const defaultSize = {
	width: 0,
	height: 0,
	isMobile: false,
	isTablet: false,
	isDesktop: false,
	isLandscape: false,
}

export const useWindowSize = () => {
	const [windowSize, setWindowSize] = useState(defaultSize)

	useEffect(() => {
		// Bail out on the server
		if (typeof window === "undefined") return

		const handleResize = () => {
			const width = window.innerWidth
			const height = window.innerHeight

			setWindowSize({
				width,
				height,
				isMobile: width < 768,
				isTablet: width >= 768 && width < 1024,
				isDesktop: width >= 1024,
				isLandscape: !isMobileDevice() || width > height,
			})
		}

		// Set size on mount
		handleResize()

		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [])

	return windowSize
}
